import React 				from 'react'
import ReactDOM         	from 'react-dom'
import classnames 			from 'classnames'
import requestFrame    		from 'request-frame'
import getNodeDimensions 	from 'get-node-dimensions'
import { isFinite } 		from 'lodash'
import {
	mapRange
} from 'canvas-sketch-util/math'

import ARYImage 			from '../ary-image'
import ParallaxEl 			from '../parallax-el'

import {
	delayedVariable
} from '../../lib/mathHelpers'

class BubbleStack extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			images,
			ratio,
			className
		} = this.props

		return <div className={ classnames('bubbleStack', className) }>
			<div className="bubbleStack-wrap"
				style={{
					paddingBottom: (isFinite(ratio) ? ratio * 100 : 100) + '%'
				}} />
			{ images && images.length > 0 ? <div className="bubbleStack-images">
				{ images.map((_image, _i) => {
					const _styles = {
						width: (_image.w * 100) + '%',
						left: (_image.x * 100) + '%',
						top: (_image.y * 100) + '%',
					}

					return <div
						key={ _i }
						style={ _styles }
						className="bubbleStack-images-image">
						<ParallaxEl
							speed={ mapRange(_i, 0, images.length, 0.05, 0.15) }
							delaySpeed={ 0.08 }>
							<div className="bubble-image">
								<ARYImage image={ _image.image } />
							</div>
						</ParallaxEl>
					</div>
				}) }
			</div> : null }
		</div>
	}

}

export default BubbleStack